import {deepOrange, green, grey, indigo, purple, teal} from "@mui/material/colors";

export const MONOSPACE_FONT = 'ui-monospace, SFMono-Regular, Menlo, Consolas, "Liberation Mono", monospace';

// Colors of the highlighted tokens (classes tok-*), chosen to keep at least a 4.5:1 contrast on light backgrounds
export const TOKEN_COLORS_SX = {
    '& .tok-comment': {color: grey[700], fontStyle: 'italic'},
    '& .tok-key': {color: indigo[700], fontWeight: 600},
    '& .tok-punct': {color: grey[600]},
    '& .tok-string': {color: green[800]},
    '& .tok-number': {color: deepOrange[800]},
    '& .tok-keyword': {color: purple[700], fontWeight: 600},
    '& .tok-indicator': {color: purple[700]},
    '& .tok-predicate': {color: teal[800]},
    '& .tok-variable': {color: deepOrange[800], fontWeight: 600}
};

export const CODE_BOX_SX = {
    p: 1.5,
    bgcolor: 'grey.100',
    borderRadius: 1,
    fontFamily: MONOSPACE_FONT,
    fontSize: '0.8rem',
    lineHeight: 1.6,
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
    maxHeight: 240,
    overflow: 'auto'
};
